import { render, staticRenderFns } from "./GptLog.vue?vue&type=template&id=fd12942e"
import script from "./GptLog.vue?vue&type=script&lang=ts"
export * from "./GptLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports